import React, { useState } from "react";
import { Dialog } from "@mui/material";
import Boton from "../Boton";
import { LogOut } from "../../helpers/Auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const DialogCloseSession = (props) => {
  const navigate = useNavigate();
  const handleClose = () => {
    props.setOpen(false);
  };
  const stay = () => {
    props.setOpen(false);
  };
  const leave = () => {
    props.setOpen(false);
    handlerClick();
  };
  const notify = (message, type = "default") =>
    toast(message, { ...type, className: "foo-bar" });
  const handlerClick = () => {
    LogOut();
    setTimeout(() => {
      navigate("/welcome", { replace: true });
      notify("Ha cerrado sesión satisfactoriamente", { type: "info" });

    }, 0);
  };
  return (
    <Dialog open={props.open} onClose={handleClose}>
      <div style={{ padding: "25px 30px" }}>
        <div className="w-100">
          <span className="text-subtitle-dark">¿Estás seguro que quieres</span>{" "}
          <span className="text-subtitle">salir de Devise</span>
          <span className="text-subtitle-dark">?</span>
        </div>
        <div className="w-100">
          <div className="btn-group mt-4 w-100 btn-group-logout">
            <div className="btn-cancel">
              <Boton
                className={"btn _btn-primary font-14"}
                handlerClick={stay}
                style={{
                  borderRadius: "8px",
                  width: "150px",
                  background: "white",
                  border: "1px solid #112e6d",
                  color: "#112e6d",
                }}
                label={"No, quedarme"}
              />
            </div>
            <div className="btn-logout">
              <Boton
                className={"btn _btn-primary font-14"}
                style={{ borderRadius: "8px", width: "150px" }}
                label={"Si, salir"}
                handlerClick={leave}
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
